import axios from 'axios';
import { IClaimMetricsTableData } from './claimMetricsPageHelper';
import { numberToCurrencyFormatter } from './helper';
import properties from '../properties';

export const filterData = (data: any) => {
  const allCostsZero = data.every((item: any) => item.total_cost === 0);
  return allCostsZero ? [] : data;
};

export const formatTopPlanPaidTableData = (data: IClaimMetricsTableData[]) => {
  return data
    ?.sort((a, b) => {
      return b?.totalPlanPaid - a?.totalPlanPaid;
    })
    .map((item: IClaimMetricsTableData) => [
      item?.category,
      item?.planImpact,
      isNaN(item?.totalPlanPaid)
        ? ''
        : numberToCurrencyFormatter(item?.totalPlanPaid, true, 0),
    ]);
};

export const getStoplossSummary = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
  quaterlyReportStore: any,
) => {
  const data = await axios
    .post(
      properties.aiqBaseUrl +
        properties.quarterlyBaseUrl +
        properties.stoplossAggregateSummary,
      {
        incurredStartDate: quaterlyReportStore.isIncurredDate
          ? incurredStartDate
          : '',
        incurredEndDate: quaterlyReportStore.isIncurredDate
          ? incurredEndDate
          : '',
        paidStartDate: quaterlyReportStore.isPaidDate ? paidStartDate : '',
        paidEndDate: quaterlyReportStore.isPaidDate ? paidEndDate : '',
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        aggregationParameter,
        max_claim_date:
          employerGroupStore.employerGroupResponseData.max_claim_date,
      },
    )
    .then((res: any) => {
      return res.data.data;
    });
  return data;
};

export const getAggregateReport = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
  quaterlyReportStore: any,
) => {
  const data = await axios
    .post(
      properties.aiqBaseUrl +
        properties.quarterlyBaseUrl +
        properties.stoplossAggregateReport,
      {
        incurredStartDate: quaterlyReportStore.isIncurredDate
          ? incurredStartDate
          : '',
        incurredEndDate: quaterlyReportStore.isIncurredDate
          ? incurredEndDate
          : '',
        paidStartDate: quaterlyReportStore.isPaidDate ? paidStartDate : '',
        paidEndDate: quaterlyReportStore.isPaidDate ? paidEndDate : '',
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        aggregationParameter,
        max_claim_date:
          employerGroupStore.employerGroupResponseData.max_claim_date,
      },
    )
    .then((res: any) => {
      return res?.data?.data;
    });
  return data;
};

export const getTotalEligible = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
  quaterlyReportStore: any,
  cohortDetailsStore: any,
) => {
  const data = await axios
    .post(
      properties.aiqBaseUrl +
        properties.quarterlyBaseUrl +
        properties.overallSummary,
      {
        incurredStartDate: quaterlyReportStore.isIncurredDate
          ? incurredStartDate
          : '',
        incurredEndDate: quaterlyReportStore.isIncurredDate
          ? incurredEndDate
          : '',
        paidStartDate: quaterlyReportStore.isPaidDate ? paidStartDate : '',
        paidEndDate: quaterlyReportStore.isPaidDate ? paidEndDate : '',
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        max_claim_date:
          employerGroupStore?.employerGroupResponseData?.max_claim_date,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        aggregationParameter,
      },
    )
    .then((res: any) => {
      return res?.data?.data;
    });
  return data;
};

export const getEmployeeDependentSpend = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
  quaterlyReportStore: any,
  cohortDetailsStore: any,
) => {
  const data = await axios
    .post(
      properties.aiqBaseUrl +
        properties.quarterlyBaseUrl +
        properties.employeeDependentSpend,
      {
        incurredStartDate: quaterlyReportStore.isIncurredDate
          ? incurredStartDate
          : '',
        incurredEndDate: quaterlyReportStore.isIncurredDate
          ? incurredEndDate
          : '',
        paidStartDate: quaterlyReportStore.isPaidDate ? paidStartDate : '',
        paidEndDate: quaterlyReportStore.isPaidDate ? paidEndDate : '',
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        aggregationParameter,
      },
    )
    .then((res: any) => {
      return res?.data?.data;
    });
  return data;
};

export const getEnrollmentsHealthCare = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
  quaterlyReportStore: any,
  max_claim_date: any,
) => {
  const baseUrl =
    properties.aiqBaseUrl +
    properties.quarterlyBaseUrl +
    properties.enrollmentHealthCare;
  const requestBody = {
    incurredStartDate: quaterlyReportStore.isIncurredDate
      ? incurredStartDate
      : '',
    incurredEndDate: quaterlyReportStore.isIncurredDate ? incurredEndDate : '',
    paidStartDate: quaterlyReportStore.isPaidDate ? paidStartDate : '',
    paidEndDate: quaterlyReportStore.isPaidDate ? paidEndDate : '',
    eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
    max_claim_date: max_claim_date,
    aggregationParameter,
  };
  const data = await axios.post(baseUrl, requestBody).then((res) => {
    if (res) {
      return res.data.data;
    }
  });
  return data;
};

export const getEmployeeDependentPlanPaid = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
  quaterlyReportStore: any,
  cohortDetailsStore: any,
) => {
  const data = await axios
    .post(
      properties.aiqBaseUrl +
        properties.quarterlyBaseUrl +
        properties.employeeDependentPlanPaid,
      {
        incurredStartDate: quaterlyReportStore.isIncurredDate
          ? incurredStartDate
          : '',
        incurredEndDate: quaterlyReportStore.isIncurredDate
          ? incurredEndDate
          : '',
        paidStartDate: quaterlyReportStore.isPaidDate ? paidStartDate : '',
        paidEndDate: quaterlyReportStore.isPaidDate ? paidEndDate : '',
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        aggregationParameter,
      },
    )
    .then((res: any) => {
      return res?.data?.data;
    });
  return data;
};

export const getRiskStratification = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
  quaterlyReportStore: any,
  cohortDetailsStore: any,
) => {
  const data = await axios
    .post(
      properties.aiqBaseUrl +
        properties.quarterlyBaseUrl +
        properties.riskStratification,
      {
        incurredStartDate: quaterlyReportStore.isIncurredDate
          ? incurredStartDate
          : '',
        incurredEndDate: quaterlyReportStore.isIncurredDate
          ? incurredEndDate
          : '',
        paidStartDate: quaterlyReportStore.isPaidDate ? paidStartDate : '',
        paidEndDate: quaterlyReportStore.isPaidDate ? paidEndDate : '',
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        max_claim_date:
          employerGroupStore?.employerGroupResponseData?.max_claim_date,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        aggregationParameter,
      },
    )
    .then(async (res: any) => {
      return res?.data?.data;
    });
  return data;
};

export const getTopChronicDiseases = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
  quaterlyReportStore: any,
  max_claim_date: any,
  type: string,
) => {
  const url =
    type === 'cost'
      ? properties.aiqBaseUrl +
        properties.quarterlyBaseUrl +
        properties.topChronicByCost
      : properties.aiqBaseUrl +
        properties.quarterlyBaseUrl +
        properties.diseasePrevalenceByMember;
  const requestBody = {
    eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
    incurredStartDate: quaterlyReportStore.isIncurredDate
      ? incurredStartDate
      : '',
    incurredEndDate: quaterlyReportStore.isIncurredDate ? incurredEndDate : '',
    paidStartDate: quaterlyReportStore.isPaidDate ? paidStartDate : '',
    paidEndDate: quaterlyReportStore.isPaidDate ? paidEndDate : '',
    max_claim_date: max_claim_date,
    claim_id_list: [],
    member_unique_id_list: [],
    aggregationParameter,
  };

  try {
    const response = await axios.post(url, requestBody);
    if (response?.status === 200) {
      return response?.data?.data?.topDiagnosis;
    }
  } catch (error) {
    throw error;
  }
};

export const getHighCostClaimants = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
  quaterlyReportStore: any,
  cohortDetailsStore: any,
) => {
  const data = await axios
    .post(
      properties.aiqBaseUrl +
        properties.quarterlyBaseUrl +
        properties.highCostClaimants,
      {
        incurredStartDate: quaterlyReportStore.isIncurredDate
          ? incurredStartDate
          : '',
        incurredEndDate: quaterlyReportStore.isIncurredDate
          ? incurredEndDate
          : '',
        paidStartDate: quaterlyReportStore.isPaidDate ? paidStartDate : '',
        paidEndDate: quaterlyReportStore.isPaidDate ? paidEndDate : '',
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        aggregationParameter,
      },
    )
    .then((res: any) => {
      return res?.data?.data;
    });
  return data;
};

export const getClaimantsDistribution = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
  quaterlyReportStore: any,
  cohortDetailsStore: any,
) => {
  const data = await axios
    .post(
      properties.aiqBaseUrl +
        properties.quarterlyBaseUrl +
        properties.claimantsDistribution,
      {
        incurredStartDate: quaterlyReportStore.isIncurredDate
          ? incurredStartDate
          : '',
        incurredEndDate: quaterlyReportStore.isIncurredDate
          ? incurredEndDate
          : '',
        paidStartDate: quaterlyReportStore.isPaidDate ? paidStartDate : '',
        paidEndDate: quaterlyReportStore.isPaidDate ? paidEndDate : '',
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        aggregationParameter,
        diagnosis_count: 3,
        diagnosis_sort_field: 'planPaid',
        diagnosis_sort_order: -1,
      },
    )
    .then((res: any) => {
      return res?.data?.data;
    });
  return data;
};

export const getPaidClaimsTrend = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
  quaterlyReportStore: any,
  cohortDetailsStore: any,
) => {
  const data = await axios
    .post(
      properties.aiqBaseUrl +
        properties.quarterlyBaseUrl +
        properties.paidClaimsTrend,
      {
        incurredStartDate: quaterlyReportStore.isIncurredDate
          ? incurredStartDate
          : '',
        incurredEndDate: quaterlyReportStore.isIncurredDate
          ? incurredEndDate
          : '',
        paidStartDate: quaterlyReportStore.isPaidDate ? paidStartDate : '',
        paidEndDate: quaterlyReportStore.isPaidDate ? paidEndDate : '',
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        claim_id_list: cohortDetailsStore.claimIdList,
        member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        aggregationParameter,
      },
    )
    .then((res: any) => {
      return res?.data?.data;
    });
  return data;
};

export const getTopPlanPaid = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
  quaterlyReportStore: any,
  isMedical: any,
) => {
  const data = await axios
    .post(
      properties.aiqBaseUrl +
        properties.quarterlyBaseUrl +
        (isMedical ? properties.medicalTopPlanPaid : properties.rxTopPlanPaid),
      {
        incurredStartDate: quaterlyReportStore.isIncurredDate
          ? incurredStartDate
          : '',
        incurredEndDate: quaterlyReportStore.isIncurredDate
          ? incurredEndDate
          : '',
        paidStartDate: quaterlyReportStore.isPaidDate ? paidStartDate : '',
        paidEndDate: quaterlyReportStore.isPaidDate ? paidEndDate : '',
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        member_unique_id_list: [],
        aggregationParameter,
      },
    )
    .then((res) => {
      return res?.data?.data;
    });
  return data;
};

export const getTopMedpharmaDrugs = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
  quaterlyReportStore: any,
  type: string,
) => {
  const baseurl = properties.aiqBaseUrl + properties.quarterlyBaseUrl;
  const endpoint =
    type === 'service'
      ? properties.topServicesInMedicalSpend
      : properties.topMedpharmaDrugs;

  const url = baseurl + endpoint;
  const requestBody = {
    eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
    incurredStartDate: quaterlyReportStore.isIncurredDate
      ? incurredStartDate
      : '',
    incurredEndDate: quaterlyReportStore.isIncurredDate ? incurredEndDate : '',
    paidStartDate: quaterlyReportStore.isPaidDate ? paidStartDate : '',
    paidEndDate: quaterlyReportStore.isPaidDate ? paidEndDate : '',
    claim_id_list: [],
    member_unique_id_list: [],
    aggregationParameter,
  };

  try {
    const response = await axios.post(url, requestBody);
    if (response?.status === 200) {
      const topDrugs = response?.data?.data;
      return topDrugs;
    }
  } catch (error) {
    throw error;
  }
};

export const getTopDrugsTableData = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
  quaterlyReportStore: any,
) => {
  const baseUrl =
    properties.aiqBaseUrl + properties.quarterlyBaseUrl + properties.topDrugs;
  const body = {
    incurredStartDate: quaterlyReportStore.isIncurredDate
      ? incurredStartDate
      : '',
    incurredEndDate: quaterlyReportStore.isIncurredDate ? incurredEndDate : '',
    paidStartDate: quaterlyReportStore.isPaidDate ? paidStartDate : '',
    paidEndDate: quaterlyReportStore.isPaidDate ? paidEndDate : '',
    eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
    aggregationParameter,
    medicationTypeList: ['Non-Speciality Drug', 'Speciality Drug'],
    pageNumber: 0,
    sortField: 'planPaid',
    sortOrder: -1,
  };
  const data = await axios.post(baseUrl, body).then((res: any) => {
    if (res?.status === 200) {
      return res?.data?.data?.topDrugs;
    }
  });
  return data;
};

export const getCareQualityMeasures = async (
  paidStartDate: any,
  paidEndDate: any,
  employerGroupStore: any,
) => {
  const data = await axios
    .post(
      properties.aiqBaseUrl +
        properties.careQualityBasicUrl +
        properties.distribution,
      {
        startDate: paidStartDate,
        endDate: paidEndDate,
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        member_unique_id_list: [],
        max_claim_date:
          employerGroupStore?.employerGroupResponseData?.max_claim_date,
      },
    )
    .then(async (res: any) => {
      return res?.data?.data.distribution;
    });
  return data;
};

export const getSavingsUtilizatonSummary = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
  quaterlyReportStore: any,
) => {
  const data = await axios
    .post(
      properties.aiqBaseUrl +
        properties.savingsUtilizationBaseUrl +
        properties.savingsUtilizatonSummary,
      {
        incurredStartDate: quaterlyReportStore.isIncurredDate
          ? incurredStartDate
          : '',
        incurredEndDate: quaterlyReportStore.isIncurredDate
          ? incurredEndDate
          : '',
        paidStartDate: quaterlyReportStore.isPaidDate ? paidStartDate : '',
        paidEndDate: quaterlyReportStore.isPaidDate ? paidEndDate : '',
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        member_unique_id_list: [],
        aggregationParameter,
      },
    )
    .then((res: any) => {
      return res?.data?.data;
    });
  return data;
};

export const getFillsAndBreakdownCostTrend = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
  quaterlyReportStore: any,
) => {
  const data = await axios
    .post(
      properties.aiqBaseUrl +
        properties.savingsUtilizationBaseUrl +
        properties.fillsAndBreakdownCostTrend,
      {
        incurredStartDate: quaterlyReportStore.isIncurredDate
          ? incurredStartDate
          : '',
        incurredEndDate: quaterlyReportStore.isIncurredDate
          ? incurredEndDate
          : '',
        paidStartDate: quaterlyReportStore.isPaidDate ? paidStartDate : '',
        paidEndDate: quaterlyReportStore.isPaidDate ? paidEndDate : '',
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        member_unique_id_list: [],
        aggregationParameter,
      },
    )
    .then((res: any) => {
      return res?.data?.data;
    });
  return data;
};

export const getSavingsProgramDetails = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
  quaterlyReportStore: any,
  program: string,
  pageNumber: number,
) => {
  const data = await axios
    .post(
      properties.aiqBaseUrl +
        properties.savingsUtilizationBaseUrl +
        properties.savingsProgramDetails,
      {
        incurredStartDate: quaterlyReportStore.isIncurredDate
          ? incurredStartDate
          : '',
        incurredEndDate: quaterlyReportStore.isIncurredDate
          ? incurredEndDate
          : '',
        paidStartDate: quaterlyReportStore.isPaidDate ? paidStartDate : '',
        paidEndDate: quaterlyReportStore.isPaidDate ? paidEndDate : '',
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        member_unique_id_list: [],
        aggregationParameter,
        program: program,
        pageNumber: pageNumber,
        pageSize: 10,
      },
    )
    .then((res: any) => {
      return res?.data?.data;
    });
  return data;
};

export const getNetworkSummary = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
  quaterlyReportStore: any,
  cohortDetailsStore: any,
  network: string,
) => {
  const baseUrl =
    properties.aiqBaseUrl +
    properties.quarterlyBaseUrl +
    properties.networkSummaryReport;
  const body = {
    incurredStartDate: quaterlyReportStore.isIncurredDate
      ? incurredStartDate
      : '',
    incurredEndDate: quaterlyReportStore.isIncurredDate ? incurredEndDate : '',
    paidStartDate: quaterlyReportStore.isPaidDate ? paidStartDate : '',
    paidEndDate: quaterlyReportStore.isPaidDate ? paidEndDate : '',
    eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
    aggregationParameter,
    network_indicator: network,
    sortField: 'planPaid',
    pageNumber: 0,
    member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
    claim_id_list: cohortDetailsStore.claimIdList,
  };
  const data = await axios.post(baseUrl, body).then((res: any) => {
    if (res) {
      return res.data?.data;
    }
  });
  return data;
};

export const getCareNavigationData = async (
  paidStartDate: any,
  paidEndDate: any,
  careNavigatorStore: any,
  isCurrentMonth: boolean,
) => {
  const startDate = paidEndDate
    ? isCurrentMonth
      ? new Date(
          new Date(paidEndDate).getFullYear(),
          new Date(paidEndDate).getMonth(),
          2,
        )
          .toISOString()
          .split('T')[0]
      : paidStartDate
    : '';
  const data = await axios
    .post(
      properties.aiqBaseUrl +
        properties.quarterlyBaseUrl +
        properties.careNavaigationData,
      {
        group_id: careNavigatorStore.group_id,
        startDate: startDate,
        endDate: paidEndDate,
      },
    )
    .then(async (res: any) => {
      if (res.status === 200) {
        return res?.data?.data;
      }
    });
  return data;
};

export const getCareNavigationMoi = async (
  paidStartDate: any,
  paidEndDate: any,
  employerGroupStore: any,
  careNavigatorStore: any,
) => {
  const data = await axios
    .post(
      properties.aiqBaseUrl +
        properties.quarterlyBaseUrl +
        properties.careNavigationMoi,
      {
        group_id: careNavigatorStore.group_id,
        pageSize: 10,
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        startDate: paidStartDate,
        endDate: paidEndDate,
      },
    )
    .then(async (res: any) => {
      if (res.status === 200) {
        return res?.data?.data;
      }
    });
  return data;
};

export const getCaseSurveys = async (careNavigatorStore: any) => {
  const data = await axios
    .post(
      properties.aiqBaseUrl +
        properties.caseSurveyBaseUrl +
        properties.getCaseSurveys,
      {
        pageNumber: 0,
        pageSize: 4,
        searchValue: '',
        groupIds: [careNavigatorStore.group_id],
      },
    )
    .then(async (res: any) => {
      if (res.status === 200) {
        return res?.data?.data;
      }
    });
  return data;
};

export const getCohortInsights = async (
  incurredStartDate: any,
  incurredEndDate: any,
  paidStartDate: any,
  paidEndDate: any,
  aggregationParameter: any,
  employerGroupStore: any,
   
  quaterlyReportStore: any,
) => {
  const data = await axios
    .post(
      properties.aiqBaseUrl +
        properties.contractBaseUrl +
        properties.getCohortAnalysis,
      {
        startDate:
          aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
        endDate:
          aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
      },
    )
    .then((res: any) => {
      return res?.data?.data;
    });
  return data;
};
